<template>

  <QuestionWrapper>
    <QuestionTitle>
      Select a practice style...
    </QuestionTitle>
    <ChoicesWrapper>
      <Choice
        v-bind:selected="question.selected"
        @click="setPracticeTime(question.id)"
        v-for="question in questions"
        >
        <ChoiceTitle>{{question.title}}</ChoiceTitle>
        <ChoiceBlurb>{{question.blurb}}</ChoiceBlurb>
        <ChoiceContext>{{question.context}}</ChoiceContext>

      </Choice>
    </ChoicesWrapper>
  </QuestionWrapper>
</template>

<script>
export default {
  data() {
    return {
      questions: [{
          title: "Wing it",
          blurb: "Find time as you go",
          context: "See how you feel, practice when you can",
          id: "5-10-min",
          selected: false
        },
        {
          title: "Scheduled",
          blurb: "Fixed time and frequency",
          context: 'Daily at 3PM, weekly for an hour, etc...',
          id: '20-30-min',
          selected: false
        },
        {
          title: "Anchored",
          blurb: "Anchor on existing habit",
          context: '5 minutes after morning coffee, after work, etc..',
          id: '1-hour',
          selected: false
        }
      ]
    }
  },
  methods: {
    setPracticeTime(questionID) {
      this.questions.forEach( (question, index) => {
        console.log(question)
        if (question.id === questionID){
            question.selected = true
        } else {
            question.selected = false
        }
      })

      this.$store.commit('setPracticeTime', questionID)
    }
  }
}
</script>

<style scoped>
.main {
  display: grid;
  grid-template-rows: 3fr 7fr 1fr;
  background: #6699ff;
  /* padding-left: 15px;
    padding-right: 15px;
    width: 85%;
    padding-left: 7.5%;
    padding-right: 7.5%;
    box-shadow: 10px;
    min-height: 5px; */
}

.title {
  display: grid;
  text-align: center;
  text-justify: center;
  color: white;
  width: 100%;
  align-self: center;
  height: 15px;
}

.next {
  display: grid;
  color: white;
  align-self: flex-end;
  text-align: center;
  margin-right: 5%;
  margin-left: 80%;
  margin-bottom: 10px;
  width: 60px;
  background: rgb(11, 42, 64);
  font-size: 15px;
}

.questions {
  text-align: left;
  color: white;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  font-size: 16px;
  text-align: center;
  text-justify: center;
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/onboarding/Question2.vue